module.exports = __webpack_public_path__ + "img/jingyingbang.f3a4ba4f.png";